// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmarks-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 28px 0 48px;
}

.bookmarks-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;
}

.bookmarks-eyebrow {
  margin: 0 0 8px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.bookmarks-header h1,
.bookmarks-empty h2,
.bookmark-item h2 {
  margin: 0;
  color: #183b3b;
}

.bookmarks-header h1 { font-size: 34px; }
.bookmarks-header p:last-child { margin: 8px 0 0; color: #637878; }
.bookmarks-header strong { color: #0f766e; font-size: 14px; }

.bookmarks-empty {
  border: 1px dashed #99d5ca;
  border-radius: 14px;
  padding: 48px 24px;
  background: #f1fbf8;
  text-align: center;
}

.bookmarks-empty > span { color: #0f766e; font-size: 36px; }
.bookmarks-empty h2 { margin-top: 10px; font-size: 22px; }
.bookmarks-empty p { margin-bottom: 0; color: #637878; }

.bookmark-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 18px;
  border-bottom: 1px solid #d7e4e5;
  overflow-x: auto;
}

.bookmark-tabs button {
  flex: 0 0 auto;
  border: 0;
  border-bottom: 3px solid transparent;
  padding: 10px 4px;
  background: transparent;
  color: #637878;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.bookmark-tabs button span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #dff3ee;
  color: #0f766e;
  font-size: 12px;
  font-weight: 700;
}

.bookmark-tabs button.active {
  border-bottom-color: #0f766e;
  color: #183b3b;
}

.bookmark-language-tabs {
  display: flex;
  gap: 7px;
  margin: 0 0 18px;
  overflow-x: auto;
}

.bookmark-language-tabs button {
  flex: 0 0 auto;
  border: 1px solid #b8d7d2;
  border-radius: 999px;
  padding: 6px 11px;
  background: #fff;
  color: #486363;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.bookmark-language-tabs button.active {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}

.bookmark-tab-empty {
  padding: 34px 24px;
}

.bookmarks-list { display: grid; gap: 12px; }

.bookmark-item {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 18px;
  border: 1px solid #d7e4e5;
  border-radius: 12px;
  padding: 18px;
  background: #fff;
}

.bookmark-meta { display: flex; gap: 8px; align-items: center; margin-bottom: 8px; }
.bookmark-meta span { color: #0f766e; font-size: 11px; font-weight: 700; text-transform: uppercase; }
.bookmark-meta .bookmark-date { margin-left: auto; color: #94a3a3; font-weight: 600; text-transform: none; }
.bookmark-item h3 { margin: 0; color: #183b3b; font-size: 21px; }
.bookmark-item p { margin: 8px 0 0; color: #486363; line-height: 1.5; }
.bookmark-item .bookmark-subtitle { color: #637878; font-style: italic; }

.bookmark-title-row { display: flex; align-items: center; gap: 8px; }

.bookmark-word-card { min-width: 0; }

.bookmark-word-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.bookmark-word-row h3 { font-size: 28px; text-transform: capitalize; }
.bookmark-word-pos { border-radius: 6px; padding: 3px 8px; background: #f3e8ff; color: #8b5cf6; font-size: 13px; font-style: italic; }
.bookmark-phonetic { color: #637878; font-size: 13px; }

.bookmark-meaning-row,
.bookmark-example-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bookmark-meaning-row p,
.bookmark-example-row p { flex: 1; }
.bookmark-example-row p { border-left: 3px solid #99d5ca; padding-left: 10px; font-style: italic; }
.bookmark-translit { color: #637878 !important; font-size: 13px; font-style: italic; }

.bookmark-synonyms {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  flex-wrap: wrap;
  color: #637878;
  font-size: 13px;
}

.bookmark-synonyms span:not(:first-child) {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 12px;
  padding: 4px 9px;
  background: #e0e7ff;
  color: #4338ca;
}

.bookmark-mini-voice {
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font-size: 10px;
  cursor: pointer;
}

.bookmark-voice {
  border: 1px solid #b8d7d2;
  border-radius: 999px;
  padding: 3px 7px;
  background: #fff;
  color: #0f766e;
  font-size: 12px;
  cursor: pointer;
}

.bookmark-voice:hover { background: #dff3ee; }
.bookmark-detail-voice { margin-top: 12px; border-radius: 7px; }

.bookmark-item .bookmark-remove {
  flex: 0 0 auto;
  border: 1px solid #f0b3a1;
  border-radius: 7px;
  padding: 7px 10px;
  background: #fff8f5;
  color: #b42318;
  cursor: pointer;
}

@media (max-width: 600px) {
  .bookmarks-page { padding-top: 16px; }
  .bookmarks-header { display: block; }
  .bookmarks-header strong { display: block; margin-top: 12px; }
  .bookmark-item { display: block; }
  .bookmark-item button { margin-top: 14px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/bookmarks.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,SAAS;EACT,cAAc;AAChB;;AAEA,uBAAuB,eAAe,EAAE;AACxC,iCAAiC,eAAe,EAAE,cAAc,EAAE;AAClE,2BAA2B,cAAc,EAAE,eAAe,EAAE;;AAE5D;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,sBAAsB,gBAAgB,EAAE,eAAe,EAAE;AACzD,qBAAqB,gBAAgB,EAAE,cAAc,EAAE;;AAEvD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB,aAAa,EAAE,SAAS,EAAE;;AAE5C;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnF,sBAAsB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AACpG,gCAAgC,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;AAC3G,oBAAoB,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAChE,mBAAmB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtE,oCAAoC,cAAc,EAAE,kBAAkB,EAAE;;AAExE,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEpE,sBAAsB,YAAY,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,wBAAwB,eAAe,EAAE,0BAA0B,EAAE;AACrE,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACrI,qBAAqB,cAAc,EAAE,eAAe,EAAE;;AAEtD;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;0BAC0B,OAAO,EAAE;AACnC,0BAA0B,8BAA8B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAClG,qBAAqB,yBAAyB,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAErF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,wBAAwB,mBAAmB,EAAE;AAC7C,yBAAyB,gBAAgB,EAAE,kBAAkB,EAAE;;AAE/D;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB,iBAAiB,EAAE;EACrC,oBAAoB,cAAc,EAAE;EACpC,2BAA2B,cAAc,EAAE,gBAAgB,EAAE;EAC7D,iBAAiB,cAAc,EAAE;EACjC,wBAAwB,gBAAgB,EAAE;AAC5C","sourcesContent":[".bookmarks-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 28px 0 48px;\n}\n\n.bookmarks-header {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.bookmarks-eyebrow {\n  margin: 0 0 8px;\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.bookmarks-header h1,\n.bookmarks-empty h2,\n.bookmark-item h2 {\n  margin: 0;\n  color: #183b3b;\n}\n\n.bookmarks-header h1 { font-size: 34px; }\n.bookmarks-header p:last-child { margin: 8px 0 0; color: #637878; }\n.bookmarks-header strong { color: #0f766e; font-size: 14px; }\n\n.bookmarks-empty {\n  border: 1px dashed #99d5ca;\n  border-radius: 14px;\n  padding: 48px 24px;\n  background: #f1fbf8;\n  text-align: center;\n}\n\n.bookmarks-empty > span { color: #0f766e; font-size: 36px; }\n.bookmarks-empty h2 { margin-top: 10px; font-size: 22px; }\n.bookmarks-empty p { margin-bottom: 0; color: #637878; }\n\n.bookmark-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid #d7e4e5;\n  overflow-x: auto;\n}\n\n.bookmark-tabs button {\n  flex: 0 0 auto;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  padding: 10px 4px;\n  background: transparent;\n  color: #637878;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.bookmark-tabs button span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  background: #dff3ee;\n  color: #0f766e;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bookmark-tabs button.active {\n  border-bottom-color: #0f766e;\n  color: #183b3b;\n}\n\n.bookmark-language-tabs {\n  display: flex;\n  gap: 7px;\n  margin: 0 0 18px;\n  overflow-x: auto;\n}\n\n.bookmark-language-tabs button {\n  flex: 0 0 auto;\n  border: 1px solid #b8d7d2;\n  border-radius: 999px;\n  padding: 6px 11px;\n  background: #fff;\n  color: #486363;\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.bookmark-language-tabs button.active {\n  border-color: #0f766e;\n  background: #0f766e;\n  color: #fff;\n}\n\n.bookmark-tab-empty {\n  padding: 34px 24px;\n}\n\n.bookmarks-list { display: grid; gap: 12px; }\n\n.bookmark-item {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 18px;\n  border: 1px solid #d7e4e5;\n  border-radius: 12px;\n  padding: 18px;\n  background: #fff;\n}\n\n.bookmark-meta { display: flex; gap: 8px; align-items: center; margin-bottom: 8px; }\n.bookmark-meta span { color: #0f766e; font-size: 11px; font-weight: 700; text-transform: uppercase; }\n.bookmark-meta .bookmark-date { margin-left: auto; color: #94a3a3; font-weight: 600; text-transform: none; }\n.bookmark-item h3 { margin: 0; color: #183b3b; font-size: 21px; }\n.bookmark-item p { margin: 8px 0 0; color: #486363; line-height: 1.5; }\n.bookmark-item .bookmark-subtitle { color: #637878; font-style: italic; }\n\n.bookmark-title-row { display: flex; align-items: center; gap: 8px; }\n\n.bookmark-word-card { min-width: 0; }\n\n.bookmark-word-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.bookmark-word-row h3 { font-size: 28px; text-transform: capitalize; }\n.bookmark-word-pos { border-radius: 6px; padding: 3px 8px; background: #f3e8ff; color: #8b5cf6; font-size: 13px; font-style: italic; }\n.bookmark-phonetic { color: #637878; font-size: 13px; }\n\n.bookmark-meaning-row,\n.bookmark-example-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bookmark-meaning-row p,\n.bookmark-example-row p { flex: 1; }\n.bookmark-example-row p { border-left: 3px solid #99d5ca; padding-left: 10px; font-style: italic; }\n.bookmark-translit { color: #637878 !important; font-size: 13px; font-style: italic; }\n\n.bookmark-synonyms {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n  color: #637878;\n  font-size: 13px;\n}\n\n.bookmark-synonyms span:not(:first-child) {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border-radius: 12px;\n  padding: 4px 9px;\n  background: #e0e7ff;\n  color: #4338ca;\n}\n\n.bookmark-mini-voice {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.bookmark-voice {\n  border: 1px solid #b8d7d2;\n  border-radius: 999px;\n  padding: 3px 7px;\n  background: #fff;\n  color: #0f766e;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.bookmark-voice:hover { background: #dff3ee; }\n.bookmark-detail-voice { margin-top: 12px; border-radius: 7px; }\n\n.bookmark-item .bookmark-remove {\n  flex: 0 0 auto;\n  border: 1px solid #f0b3a1;\n  border-radius: 7px;\n  padding: 7px 10px;\n  background: #fff8f5;\n  color: #b42318;\n  cursor: pointer;\n}\n\n@media (max-width: 600px) {\n  .bookmarks-page { padding-top: 16px; }\n  .bookmarks-header { display: block; }\n  .bookmarks-header strong { display: block; margin-top: 12px; }\n  .bookmark-item { display: block; }\n  .bookmark-item button { margin-top: 14px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
